<div class="card-container">
  <div class="card-header-wrapper">
    <div class="">
      <div class="row">
        <div class="col-md-12">
          <button
            kendoButton
            (click)="goBack()"
            icon="arrow-chevron-left"
            look="clear"
          >
            Go Back
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h3 class="card-title">Document</h3>
        </div>
      </div>
    </div>
  </div>

  <div class="card-component">
    <div class="">
      <div class="row">
        <div class="col-md-12 text-center">
          <ng-container
            *ngIf="
              documentType != null &&
              documentType != '' &&
              documentType != 'video'
            "
          >
            <img class="image-container" src="{{ documentID }}" style="width: 100%" />
          </ng-container>
          <ng-container
            *ngIf="
              documentType != null &&
              documentType != '' &&
              documentType === 'video'
            "
          >
            <video controls  class="video-container">
              <source src="{{ documentID }}" type="video/mp4" />
              <source src="{{ documentID }}" type="video/webm" />
              <source src="{{ documentID }}" type="video/ogg" />
              Your browser does not support the video tag.
            </video>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
